import { render, staticRenderFns } from "./menuButton.vue?vue&type=template&id=3e25cc39&scoped=true&"
import script from "./menuButton.vue?vue&type=script&lang=js&"
export * from "./menuButton.vue?vue&type=script&lang=js&"
import style0 from "./menuButton.vue?vue&type=style&index=0&id=3e25cc39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e25cc39",
  null
  
)

export default component.exports